import { ScrollView } from 'react-native';
import Modal from 'react-modal';
import EntypoIcon from 'react-native-vector-icons/dist/Entypo';
import EvilIconsIcon from 'react-native-vector-icons/dist/EvilIcons';
import FeatherIcon from 'react-native-vector-icons/dist/Feather';
import FontAwesomeIcon from 'react-native-vector-icons/dist/FontAwesome';
import FoundationIcon from 'react-native-vector-icons/dist/Foundation';
import IoniconsIcon from 'react-native-vector-icons/dist/Ionicons';
import MaterialCommunityIconsIcon
  from 'react-native-vector-icons/dist/MaterialCommunityIcons';
import MaterialIconsIcon from 'react-native-vector-icons/dist/MaterialIcons';
import OcticonsIcon from 'react-native-vector-icons/dist/Octicons';
import SimpleLineIconsIcon
  from 'react-native-vector-icons/dist/SimpleLineIcons';
import ZocialIcon from 'react-native-vector-icons/dist/Zocial';

import FlatList from './components/FlatList';

module.exports = {
  KeyboardAwareScrollView: ScrollView,
  NavigationActions: {},
  EntypoIcon,
  EvilIconsIcon,
  FeatherIcon,
  FontAwesomeIcon,
  FoundationIcon,
  IoniconsIcon,
  MaterialCommunityIconsIcon,
  MaterialIconsIcon,
  OcticonsIcon,
  SimpleLineIconsIcon,
  ZocialIcon,
  Modal,
  FlatList,
  Keyboard: {},
  codePush: {},
  Toast: {},
  ToastDuration: {},
};



// WEBPACK FOOTER //
// ./src/modules.web.js